import { Checkbox } from '@mui/material'
import useStyles from './useStyles'

function TableHeader ({ toggleAll, allChecked, indeterminate }) {
  const classes = useStyles()
  return (
    <thead className={classes.row}>
      <tr>
        <th className={classes.headCheck}>
          <Checkbox />
        </th>
        <th className={classes.headStatus}>Estado del usuario</th>
        <th className={classes.headName}>Nombre</th>
        <th className={classes.headNameLegal}>Nombre legal</th>
        <th className={classes.headCUIT}>CUIT</th>
        <th className={classes.headType}>Tipo de usuario</th>
        <th className={classes.headKebab}></th>
      </tr>
    </thead>
  )
}

export default TableHeader
